import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/sagivbengiat/cloned_projects/react-elastic-carousel/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import Carousel from 'react-elastic-carousel';
import Item from '../components/SimpleItem';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "breakpoints"
    }}>{`breakPoints`}</h1>
    <p><em parentName="p">{`This is the coolest feature and one of the main reasons that `}<inlineCode parentName="em">{`react-elastic-carousel`}</inlineCode>{` was written.`}</em></p>
    <p>{`The `}<inlineCode parentName="p">{`breakPoints`}</inlineCode>{` array, allows you to set different `}<inlineCode parentName="p">{`props`}</inlineCode>{` for different sizes of the element, regardless to the window's size.`}<br parentName="p"></br>{`
`}{`This is due to the fact that `}<inlineCode parentName="p">{`react-elastic-carousel`}</inlineCode>{` is listening to the element's `}<inlineCode parentName="p">{`resize`}</inlineCode>{` event instead of the window.`}</p>
    <h4 {...{
      "id": "you-can-pass-an-array-of-objects-that-will-signal-react-elastic-carousel-to-change-props-like-itemstoshow-and-itemstoscroll-and-others-on-different-width-values"
    }}>{`You can pass an array of objects that will signal `}<inlineCode parentName="h4">{`react-elastic-carousel`}</inlineCode>{` to change props like `}<inlineCode parentName="h4">{`itemsToShow`}</inlineCode>{` and `}<inlineCode parentName="h4">{`itemsToScroll`}</inlineCode>{` (and others) on different `}<inlineCode parentName="h4">{`width`}</inlineCode>{` values.`}</h4>
    <p><strong parentName="p">{`ANY`}</strong>{` prop can be passed directly to React Elastic Carousel or via a the breakpoint object. Keep in mind that a prop passed via a breakpoint will override a direct prop. `}</p>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <p>{`(`}<em parentName="p">{`Resize the container to see the changes...`}</em>{`)`}</p>
    <Playground __position={0} __code={'class App extends React.Component {\n    constructor(props) {\n      super(props)\n      this.breakPoints = [\n        { width: 1, itemsToShow: 1 },\n        { width: 550, itemsToShow: 2, itemsToScroll: 2, pagination: false },\n        { width: 850, itemsToShow: 3 },\n        { width: 1150, itemsToShow: 4, itemsToScroll: 2 },\n        { width: 1450, itemsToShow: 5 },\n        { width: 1750, itemsToShow: 6 },\n      ]\n    }\n    render() {\n      return (\n        <Carousel breakPoints={this.breakPoints}>\n          <Item>1</Item>\n          <Item>2</Item>\n          <Item>3</Item>\n          <Item>4</Item>\n          <Item>5</Item>\n          <Item>6</Item>\n        </Carousel>\n      )\n    }\n  }'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Carousel,
      Item,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  {class App extends React.Component {
        constructor(props) {
          super(props);
          this.breakPoints = [{
            width: 1,
            itemsToShow: 1
          }, {
            width: 550,
            itemsToShow: 2,
            itemsToScroll: 2,
            pagination: false
          }, {
            width: 850,
            itemsToShow: 3
          }, {
            width: 1150,
            itemsToShow: 4,
            itemsToScroll: 2
          }, {
            width: 1450,
            itemsToShow: 5
          }, {
            width: 1750,
            itemsToShow: 6
          }];
        }

        render() {
          return <Carousel breakPoints={this.breakPoints} mdxType="Carousel">
            <Item mdxType="Item">1</Item>
            <Item mdxType="Item">2</Item>
            <Item mdxType="Item">3</Item>
            <Item mdxType="Item">4</Item>
            <Item mdxType="Item">5</Item>
            <Item mdxType="Item">6</Item>
          </Carousel>;
        }

      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      